import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
// import Callback from './views/Callback.vue'
// import NotFound from './views/NotFound.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/callback*',
      name: 'callback',
      component: () => import('@/views/Callback'),
      props: (route) => ({
        parameters: route.query
      })
    },
    {
      path: '*',
      name: 'home',
      component: () => import('@/views/Home'),
      props: (route) => ({
        parameters: route.query
      })
    } // ,
    // {
    //   path: '*',
    //   name: 'notFound',
    //   component: NotFound
    // }
  ]
})
